export const Environment = {
  production: true,
  apiUrl: './api'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts